import {default as Component} from './NavigationComponent'

const NavigationComponent = Component

export default NavigationComponent


// WEBPACK FOOTER //
// ./src/components/NavigationComponent/index.js